module.exports = __webpack_public_path__ + "static/media/maximum.8cd6dec8.png";